import { render, staticRenderFns } from "./OrderProductsModal.vue?vue&type=template&id=72c188ab&scoped=true"
import script from "./OrderProductsModal.vue?vue&type=script&lang=js"
export * from "./OrderProductsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c188ab",
  null
  
)

export default component.exports